import type { PortfolioItemGroupName } from './generated/gql-enums';

export const PORTFOLIO_ITEM_GROUP_BANK_ACCOUNTS = 'BANK_ACCOUNTS' satisfies PortfolioItemGroupName;
export const PORTFOLIO_ITEM_GROUP_COMPANY_EQUITY = 'COMPANY_EQUITY' satisfies PortfolioItemGroupName;
export const PORTFOLIO_ITEM_GROUP_OTHER_ASSETS = 'OTHER_ASSETS' satisfies PortfolioItemGroupName;
export const PORTFOLIO_ITEM_GROUP_OTHER_INVESTMENTS = 'OTHER_INVESTMENTS' satisfies PortfolioItemGroupName;
export const PORTFOLIO_ITEM_GROUP_OTHER_LIABILITIES = 'OTHER_LIABILITIES' satisfies PortfolioItemGroupName;
export const PORTFOLIO_ITEM_GROUP_REAL_ESTATE = 'REAL_ESTATE' satisfies PortfolioItemGroupName;
export const PORTFOLIO_ITEM_GROUP_SAVVY_ACCOUNTS = 'SAVVY_ACCOUNTS' satisfies PortfolioItemGroupName;
